<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="mx-auto" max-width="600">
      <v-card-title class="headline">
        <v-row>
          <v-col cols="1">
            <!--<v-icon color="orange darken-2">warning</v-icon>-->
            <v-icon color="orange darken-2">warning</v-icon>
          </v-col>
          <v-col cols="8">
            <span class="headline">{{ title }}</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="white-space: pre-wrap; word-wrap: break-word">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="cancel">キャンセル</v-btn>
        <v-btn color="primary" text @click="confirm">{{ buttonMessage }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    title: String,
    message: String,
    buttonMessage: String,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
    },
    confirm() {
      this.dialog = false;
      this.$emit('confirm');
    },
  },
};
</script>
